import Coremetrics from '@component/common/src/util/Coremetrics';
import TagManagerUtil from '@component/common/src/util/TagManagerUtil';
import { Actions as CitiActions } from '@feature/citi-redirects/src/util/Constants';

const $ = require('jquery');
const Backbone = require('backbone');
const Logger = require('@component/common/src/util/Logger');

function setupConfigs(App) {
  let configs = {};
  try {
    configs = JSON.parse($('script[data-bootstrap="configs"]').html());
  } catch (e) {
    Logger.log('Error:', e, 'parsing data-bootstrap script block html as JSON.');
  }
  App.configs = configs; // eslint-disable-line no-param-reassign
}

function setupFeature(App) {
  App.on('start', () => {
    setupConfigs(App);
    // require('../common/header-footer')(App.brand);
    Backbone.history.stop();
    Backbone.history.start({
      pushState: true,
      silent: false,
    });
  });

  App.channel.on('do:nav', ({
    href,
    trigger = true,
    replace = true,
  }) => {
    Logger.log('PAGE APP do:nav', {
      href,
      trigger,
      replace,
    });
    App.router.navigate(href, {
      trigger,
      replace,
    });
  });

  // This event gets fired from either credit-gateway or the my-account dashboard
  // This CM tag should be fired once per session, once a credit session has started
  // Event callback checks sessionStorage for "creditTagFired" to check if it
  // has already been fired.
  App.channel.on('credit:session:started', (pageId, spTag) => {
    const tagFired = sessionStorage.getItem('creditTagFired');
    if (!tagFired) {
      sessionStorage.setItem('creditTagFired', 'true');
      Coremetrics.createLinkClickTag({
        pageID: pageId,
        href: `cm_sp=${spTag}`,
        type: '8',
      });
    }
  });

  // listen for tealium events

  App.channel.on(CitiActions.tealium.linkTag, (obj) => {
    // generic linkTag handler
    TagManagerUtil.fireTag('link', obj);
  });
}

export default setupFeature;
export {
  setupFeature,
  setupConfigs,
};
